import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import PageHeader from '../shared/PageHeader'
import SectionCard from '../shared/SectionCard'

export default withTranslation()(function TeamAccess({ t }) {
  const sections = [
    {
      url: '/settings/user-management',
      icon: UIcons.UilBuilding,
      color: 'blue',
      title: t('settings.team_access.users.title'),
      description: t('settings.team_access.users.description'),
      items: [
        t('settings.team_access.users.items.management'),
        t('settings.team_access.users.items.invite'),
        t('settings.team_access.users.items.status'),
        t('settings.team_access.users.items.activity')
      ]
    },
    {
      url: '/settings/role-management',
      icon: UIcons.UilUsersAlt,
      color: 'purple',
      title: t('settings.team_access.roles.title'),
      description: t('settings.team_access.roles.description'),
      items: [
        t('settings.team_access.roles.items.roles'),
        t('settings.team_access.roles.items.permissions'),
        t('settings.team_access.roles.items.assignment'),
        t('settings.team_access.roles.items.activity')
      ]
    }
  ]

  return (
    <section className="w-full">
      <PageHeader
        crumbs={[
          { name: t('settings.hub.title'), url: '/settings' },
          { name: t('settings.team_access.title') }
        ]}
        title={t('settings.team_access.title')}
      />

      <div className="grid gap-5 md:grid-cols-2">
        {
          sections.map((section) => <SectionCard key={section.url} {...section} />)
        }
      </div>
    </section>
  )
})
